import {useToggle} from "usehooks-ts";
import React, {useEffect, useMemo, useState} from "react";
import {getHttpClient, swrFetcher} from "../../../utils/api.ts";
import {FiDownload, FiTrash} from "react-icons/fi";
import useSWR from "swr";
import {MdDriveFileMoveOutline} from "react-icons/md";
import FormGroup from "../../../components/form/FormGroup.tsx";
import Select from "../../../components/form/Select.tsx";
import {useAssetSelector} from "./useAssetSelector.ts";
import {AssetResponseItem, FolderAsset} from "../../../@types/AssetTypes.ts";
import Modal from "@/components/Modal.tsx";
import {closeModal, openDrawer, openModal} from "@/components/dispatch_functions.ts";


export function DownloadModal() {
    const [visible, toggle] = useToggle()
    const selected_items = useAssetSelector((state)=>state.selectedAssets)
    const [loading, setLoading] = useState(false)
    const [url, setUrl] = useState('')
    useEffect(() => {
        if(visible){
            setLoading(true)
            getHttpClient().post('/assets/bulk/download', {
                ids: selected_items,
            }).then(({data})=>{
                setLoading(false)
                setUrl(data.url)
            })
        }
    }, [visible]);
    return (
        <>
            <button className={"btn btn-outline-secondary"}
                    disabled={!Array.isArray(selected_items) || selected_items.length === 0}
                    onClick={() => {
                        openModal("download")
                        setUrl('')
                        toggle()
                    }} title={"Download selected files"}>
                <FiDownload/>
            </button>
            <Modal id={"download"} title={"Download"}>
                <div className="text-center">
                    {
                        loading ? <span>Just a moment...</span> : <a
                            className={"link text-primary"}
                            href={url} target={"_blank"}
                                                                     download>Click here to Download</a>
                    }
                </div>
            </Modal></>
    )
}

export function MoveToModal({mutate}){
    const {data} = useSWR<{assets: AssetResponseItem[]}>('/assets?type=folder', swrFetcher);
    const clearSelection = useAssetSelector((state)=>state.clearSelection)
    const selected_items = useAssetSelector((state)=>state.selectedAssets)

    const folders = useMemo(()=>{
        return data?.assets.map((i)=>{
            return {
                label: (i.data as FolderAsset).name,
                value: i.id
            }
        }) || []
    },[data])
    const [loading, setLoading] = useState(false)
    const [selectedFolder, setSelectedFolder] = useState<string>()

    const onSubmit = ()=>{
        if(selectedFolder){
            setLoading(true)
            getHttpClient().post('/assets/bulk/move', {
                parent_id: selectedFolder,
                ids: selected_items,
            }).then(()=>{
                clearSelection()
                mutate().then(()=>{
                    closeModal("move-modal")
                    setLoading(false)
                })
            })
        }
    }
    return <>
        <button className={"btn btn-outline-secondary"}
                disabled={!Array.isArray(selected_items) || selected_items.length === 0}
                onClick={()=>openModal('move-modal')} title={"Move selected files"}>
            <MdDriveFileMoveOutline/>
        </button>
        <Modal
            id={"move-modal"}
            okText={"Move"}
            confirmLoading={loading}
            title={`Move ${selected_items.length} items`}
            onSubmit={onSubmit}>
            <div className="mb-3">
                <label className={"label"}>Move {selected_items.length} items to</label>
                <div>
                    <Select onChange={(str)=>setSelectedFolder(String(str))} options={folders}
                            hasEmpty
                    />
                </div>
            </div>
        </Modal>
    </>
}

export function DeleteModal({mutate}) {
    const clearSelection = useAssetSelector((state)=>state.clearSelection)
    const selected_items = useAssetSelector((state) => state.selectedAssets)
    const [loading, setLoading] = useState(false)
    const deleteSelectedFiles = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation()
        }
        setLoading(true)
        getHttpClient().post('/assets/bulk/delete', {
            ids: selected_items
        }).then(() => {
            mutate()
            clearSelection()
            setLoading(false)
            closeModal('delete-modal')
        })
    }
    return (
        <>
            <button className={"btn text-danger btn-outline-secondary"}
                    onClick={()=>openModal('delete-modal')}
                    disabled={!Array.isArray(selected_items) || selected_items.length === 0}
                    title={"Delete selected files"}>
                <FiTrash/>
            </button>
            <Modal
                id={'delete-modal'}
                   confirmLoading={loading}
                   title={"Confirm Delete"}
                   okText={"Delete files"}
                   submitBtnClass={"btn-error"}
                   onSubmit={deleteSelectedFiles}>
                <p>The selected files would be deleted from the assets</p>
            </Modal>

        </>
    )
}
